/** @jsx h */
import { useGlobal } from './use-global'

const impl = () => ({
  step: step => window.dataLayer.push({ event: step }),
  confirmation: ({ boutiqueId, selectedCountry, purpose, boutiqueName, type, prefLanguage, channel, email }) => {
    window.dataLayer.push({
      event: 'baa_confirmation',
      appointment_id: null,
      boutique_id: boutiqueId,
      appointment_country: selectedCountry,
      visit_purpose: purpose,
      preferred_language: prefLanguage,
      boutique_name: boutiqueName,
      appointment_type: type,
      communication_channel: channel,
      user_email: email
    })
  }
})

const useAnalytics = () => {
  const [{ canvasConfig }] = useGlobal()

  const getFunction = name => {
    if (!canvasConfig.useAnalytics) return () => {}
    try {
      const method = impl()[name]
      if (method) return method
      throw new Error('method not found')
    } catch (err) {
      console.log(err)
      return () => {}
    }
  }

  return {
    trackStep: step => getFunction('step')(step),
    trackConfirmation: data => getFunction('confirmation')(data)
  }
}

export default useAnalytics
